import {ReactNode} from "react";
import {CommonTranslKey} from "../CommonTranslKey";
import {useTranslation} from "react-i18next";
import Button from "./Button";
import {Variant} from "../Variant";

export interface CommonButtonProps {
    variant?: Variant;
    onClick: () => void;
    disabled?: boolean;
}

export function AddButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.ADD)}</CommonButtonImpl>;
}

export function CancelButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.CANCEL)}</CommonButtonImpl>;
}

export function DeleteButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl variant={Variant.ERROR} {...props}>{t(CommonTranslKey.DELETE)}</CommonButtonImpl>;
}

export function DetailButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.DETAILS)}</CommonButtonImpl>;
}

export function EditButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.EDIT)}</CommonButtonImpl>;
}

export function InvalidateButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl variant={Variant.ERROR} {...props}>{t(CommonTranslKey.INVALIDATE)}</CommonButtonImpl>;
}

export function SaveButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.SAVE)}</CommonButtonImpl>;
}

export function SearchButton(props: CommonButtonProps) {
    const {t} = useTranslation();
    return <CommonButtonImpl {...props}>{t(CommonTranslKey.SEARCH)}</CommonButtonImpl>;
}


interface CommonButtonImplProps extends CommonButtonProps {
    children: ReactNode;
}

function CommonButtonImpl(props: CommonButtonImplProps) {
    const {variant, onClick, children, disabled} = props;
    return (
        <Button variant={variant ?? Variant.PRIMARY}
                onClick={onClick}
                disabled={disabled}>
            {children}
        </Button>
    );
}
